import { Module } from "vuex";
import { RootState } from "@/store/modules/root/interfaces";
import { AIAssessmentState } from "./interfaces";
import actions from "./actions";
import mutations from "./mutations";
import getters from "./getters";

const state: AIAssessmentState = {
  isLoading: false,
  error: null,
  sessionId: null,
  chatLog: [],
  questions: [],
  assessmentData: null,
  showResultModal: false,
  loadingContext: null,
  isEditMode: false,
  editingQuestionIndex: null,
  streamingMessage: null
};

const module: Module<AIAssessmentState, RootState> = {
  namespaced: true,
  state,
  actions,
  mutations,
  getters
};

export default module;
